/* RnR progressive enhancements.
   Additive only: nothing here is required for the page to work, and every hook
   exits quietly if its target or dependency is absent. */
(function () {
  'use strict';


  /* The announcement bar used to carry fifteen city names, which wrapped to
     four lines on a phone, so they were scrolled sideways to keep the bar one
     line tall. Those names now have a band of their own under the install
     gallery, and the bar carries a sentence instead -- a sentence that scrolled
     sideways under the close button and read as an advert. Wrapping to two
     lines is the right answer for a sentence, so the marquee is gone. */

  /* Tap a neighbouring testimonial to bring it to centre.
     Motion's section only offers the page dots, so the visible side cards look
     interactive but are not. The Flickity instance is reached through
     Flickity.data() rather than by editing Motion's section or theme.js.
     The dots remain the keyboard path; this is a pointer convenience. */
  function testimonialTapToCentre() {
    document.querySelectorAll('[data-section-type="testimonials"]').forEach(function (section) {
      var slideshow = section.querySelector('[id^="Testimonials-"]');
      if (!slideshow || slideshow.dataset.rnrTapBound) return;
      slideshow.dataset.rnrTapBound = 'true';

      slideshow.addEventListener('click', function (event) {
        var slide = event.target.closest('.testimonials-slide');
        if (!slide || slide.classList.contains('is-selected')) return;
        // Let real links and buttons inside a card behave normally.
        if (event.target.closest('a, button')) return;

        var flickity = window.Flickity && window.Flickity.data(slideshow);
        if (!flickity || typeof flickity.select !== 'function') return;

        var index = parseInt(slide.dataset.index, 10);
        if (isNaN(index)) return;
        event.preventDefault();
        flickity.select(index);
      });
    });
  }

  /* Motion initialises its testimonial slideshow with prevNextButtons:false and
     theme.js is core, so the arrows cannot be turned on there. These drive the
     existing Flickity page dots instead of reaching into the instance -- the
     dots are already wired and keyboard-accessible, so this stays working even
     if Motion changes its internals. */
  /* Motion initialises the testimonial slideshow through initWhenVisible, which
     is not firing here -- the sections use content-visibility, which can stop
     the observer resolving. theme.js is core so the fix cannot go there.
     This initialises the slideshow only if Motion has not already done so, and
     uses cellAlign:left with contain:true so the equal cards group from the
     left rather than centring one. */
  function testimonialSlideshowFallback() {
    if (!window.theme || typeof theme.Slideshow !== 'function') return;
    document.querySelectorAll('[data-section-type="testimonials"]').forEach(function (section) {
      var slideshow = section.querySelector('[id^="Testimonials-"]');
      if (!slideshow) return;
      if (slideshow.classList.contains('flickity-enabled')) return;
      if (section.querySelectorAll('.testimonials-slide').length < 2) return;
      try {
        new theme.Slideshow(slideshow, {
          adaptiveHeight: false,
          avoidReflow: true,
          pageDots: true,
          prevNextButtons: false,
          cellAlign: 'left',
          contain: true
        });
      } catch (e) { /* leave the static list rather than breaking the section */ }
    });
  }


  /* Motion's testimonial markup carries no element for an avatar, so one is
     built from the author's first initial. Uniform colour on purpose -- a
     different colour per person reads as a category, which it is not. */
  function testimonialAvatars() {
    document.querySelectorAll('.testimonials-slide .testimonial-meta').forEach(function (meta) {
      if (meta.querySelector('.rnr-avatar')) return;
      var cite = meta.querySelector('cite');
      if (!cite) return;
      var initial = (cite.textContent || '').trim().charAt(0).toUpperCase();
      if (!initial) return;
      var el = document.createElement('span');
      el.className = 'rnr-avatar';
      el.setAttribute('aria-hidden', 'true');
      el.textContent = initial;
      meta.insertBefore(el, meta.firstChild);
    });
  }


  /* The clamp cuts the tail off the longer reviews, so anything actually
     truncated gets a toggle. Flickity marks every unselected cell aria-hidden
     even while it is plainly on screen; a focusable control inside aria-hidden
     is worse than static text is, so the button's tabindex tracks the cell. */
  function testimonialReadMore() {
    document.querySelectorAll('.testimonials-slide .testimonials-slider__text').forEach(function (card) {
      var quote = card.querySelector('.rte-setting');
      if (!quote) return;
      /* A lone quote is not clamped, so there is nothing to expand. */
      if (card.closest('.testimonials-section--single')) return;
      var existing = card.querySelector('.rnr-quote-toggle');
      var clipped = quote.scrollHeight > quote.clientHeight + 2;
      if (!clipped && !quote.classList.contains('is-expanded')) {
        if (existing) existing.parentNode.removeChild(existing);
        return;
      }
      if (existing) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rnr-quote-toggle';
      btn.textContent = 'Read more';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var open = quote.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', String(open));
        btn.textContent = open ? 'Show less' : 'Read more';
        equalizeTestimonialHeights();
      });
      card.appendChild(btn);
    });
    syncTestimonialFocus();
  }

  /* Flickity marks every cell it has not "selected" as aria-hidden, including
     the two that are plainly on screen beside the selected one. Left alone that
     hides two of the three visible reviews from assistive tech and strands
     their buttons out of the tab order. Visibility here is measured against
     the viewport box rather than taken from Flickity's word for it. Attributes
     are only written when they actually change, so the observer settles
     instead of looping. */
  function syncTestimonialFocus() {
    document.querySelectorAll('[data-section-type="testimonials"]').forEach(function (section) {
      var viewport = section.querySelector('.flickity-viewport');
      var box = viewport ? viewport.getBoundingClientRect() : null;
      section.querySelectorAll('.testimonials-slide').forEach(function (slide) {
        var visible = true;
        if (box) {
          var r = slide.getBoundingClientRect();
          visible = r.right > box.left + 1 && r.left < box.right - 1;
        }
        var marked = slide.getAttribute('aria-hidden') === 'true';
        if (visible && marked) slide.removeAttribute('aria-hidden');
        if (!visible && !marked) slide.setAttribute('aria-hidden', 'true');
        slide.querySelectorAll('.rnr-quote-toggle').forEach(function (btn) {
          if (visible) btn.removeAttribute('tabindex');
          else if (btn.getAttribute('tabindex') !== '-1') btn.setAttribute('tabindex', '-1');
        });
      });
    });
  }

  /* Flickity flips aria-hidden as the carousel moves, and it does so without
     firing anything we already listen to. */
  function watchTestimonialVisibility() {
    if (!window.MutationObserver) return;
    document.querySelectorAll('[data-section-type="testimonials"]').forEach(function (section) {
      if (section.hasAttribute('data-rnr-quote-watch')) return;
      section.setAttribute('data-rnr-quote-watch', '');
      new MutationObserver(syncTestimonialFocus).observe(section, {
        subtree: true, attributes: true, attributeFilter: ['aria-hidden']
      });
    });
  }

  /* Each related-post card carries a link on the image and another on the
     title, both to the same article. The title is now stretched across the
     card, so the image link is covered for a mouse but would still take a tab
     stop and repeat the same name to a screen reader. */
  function relatedCardLinks() {
    document.querySelectorAll('.article__grid-image').forEach(function (imgLink) {
      var card = imgLink.closest('.grid__item');
      if (!card || !card.querySelector('.article__title')) return;
      imgLink.setAttribute('tabindex', '-1');
      imgLink.setAttribute('aria-hidden', 'true');
    });
  }

  /* With three reviews and three columns there is nothing to page to, so the
     controls come off and dragging is disabled. Flickity is left initialised
     rather than destroyed - the equal-height rules depend on .flickity-enabled,
     and tearing it down would collapse the row. The threshold is the number of
     columns actually showing, so a narrow viewport that fits fewer keeps its
     controls. */
  function testimonialsPerView() {
    if (window.matchMedia('(min-width: 1024px)').matches) return 3;
    if (window.matchMedia('(min-width: 750px)').matches) return 2;
    return 1;
  }

  function testimonialStatic() {
    document.querySelectorAll('[data-section-type="testimonials"]').forEach(function (section) {
      var slides = section.querySelectorAll('.testimonials-slide');
      var fits = slides.length > 0 && slides.length <= testimonialsPerView();
      section.classList.toggle('rnr-testimonials--static', fits);
      if (fits) {
        section.dataset.rnrStatic = '1';
        var nav = section.querySelector('.rnr-carousel-nav');
        if (nav) nav.parentNode.removeChild(nav);
        var dots = section.querySelector('.flickity-page-dots');
        if (dots) dots.parentNode.removeChild(dots);
      } else {
        delete section.dataset.rnrStatic;
      }
      var slider = section.querySelector('.testimonials-slider');
      if (!slider || !window.Flickity || !window.Flickity.data) return;
      var f = window.Flickity.data(slider);
      if (!f) return;
      if (f.options.draggable !== !fits) {
        f.options.draggable = !fits;
        if (typeof f.updateDraggable === 'function') f.updateDraggable();
      }
    });
  }


  /* Google rating beside each testimonials heading. The markup is a <template>
     in the layout so the values come from Theme settings and Motion's section
     file stays untouched. */
  function googleBadge() {
    var tpl = document.getElementById('RnrGoogleBadge');
    if (!tpl) return;
    document.querySelectorAll('[data-section-type="testimonials"]').forEach(function (section) {
      if (section.querySelector('.rnr-gbadge')) return;
      var header = section.querySelector('.section-header');
      if (!header) return;
      header.appendChild(tpl.content.cloneNode(true));
    });
  }


  /* Preview-only nav item.

     Shopify menus are store-level, so adding InnovaSpas in the admin would put
     it in the live store's nav too, pointing at a page the published theme
     cannot render. This injects it in our theme only.

     It clones an existing sibling rather than building markup, so it inherits
     whatever classes and handlers Motion puts on a nav link. Delete the Theme
     settings values once the real menu item exists. */
  /* Motion renders this nav in three different shapes: <a> + <ul> in the
     footer, <details><summary> + <ul> on desktop, and
     div.mobile-nav__has-sublist + div.mobile-nav__sublist in the drawer. Both
     injectors below resolve through these two helpers, because targeting only
     the first two shapes silently skipped mobile entirely. */
  function navParentLink(li) {
    return li.querySelector(':scope > a, :scope > details > summary')
        || li.querySelector(':scope > .mobile-nav__has-sublist > a, :scope > .mobile-nav__has-sublist > button, :scope > .mobile-nav__has-sublist');
  }
  function navSublist(li) {
    var sub = li.querySelector(':scope > ul, :scope > details > ul, :scope > .mobile-nav__sublist');
    if (!sub) return null;
    /* The drawer wraps its items in a div; the element that actually holds the
       <li> children is what we need to append to. */
    if (!sub.querySelector(':scope > li')) {
      var inner = sub.querySelector('ul');
      if (inner) return inner;
    }
    return sub;
  }

  function navLabel(el) {
    /* .mobile-nav__has-sublist contains the label AND the expand control, so
       textContent picks up both. Take the first non-empty text node. */
    var t = '';
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) { t = n.textContent; break; }
      if (n.nodeType === 1 && (n.tagName === 'A' || n.tagName === 'SPAN') && n.textContent.trim()) { t = n.textContent; break; }
    }
    if (!t) t = el.textContent || '';
    return t.trim().toLowerCase();
  }

  function previewNavExtra() {
    var label = window.RNR_NAV_EXTRA && window.RNR_NAV_EXTRA.label;
    var url   = window.RNR_NAV_EXTRA && window.RNR_NAV_EXTRA.url;
    var parent= (window.RNR_NAV_EXTRA && window.RNR_NAV_EXTRA.parent) || 'Shop';
    if (!label || !url) return;

    function inject(root) {
      var items = root.querySelectorAll('li');
      for (var i = 0; i < items.length; i++) {
        var li = items[i];
        /* Two shapes: a plain link plus a list in the drawer, and
           <details><summary> for the desktop dropdowns. */
        var link = navParentLink(li);
        if (!link) continue;
        if (navLabel(link) !== parent.toLowerCase()) continue;
        var sub = navSublist(li);
        if (!sub) continue;
        if (sub.querySelector('[data-rnr-nav-extra]')) return;
        var sibling = sub.querySelector(':scope > li');
        if (!sibling) return;
        var clone = sibling.cloneNode(true);
        var a = clone.querySelector('a');
        if (!a) return;
        clone.setAttribute('data-rnr-nav-extra', '');
        a.setAttribute('href', url);
        a.removeAttribute('aria-current');
        var textNode = null;
        a.childNodes.forEach(function (n) { if (n.nodeType === 3 && n.textContent.trim()) textNode = n; });
        if (textNode) { textNode.textContent = label; } else { a.textContent = label; }
        sub.appendChild(clone);
        return;
      }
    }
    document.querySelectorAll('.site-nav, #NavDrawer, .drawer').forEach(inject);
  }

  /* The nine series and length pages exist in Shopify but are hidden, so their
     real URLs 404 until cutover. These preview links point at the ?view= form,
     which renders the same template. Preview theme only - the real menu items
     replace them when the pages go visible. */
  function previewNavSeries() {
    var groups = window.RNR_NAV_SERIES;
    if (!groups || !groups.length) return;

    function inject(root) {
      var items = root.querySelectorAll('li');
      for (var i = 0; i < items.length; i++) {
        var li = items[i];
        var link = navParentLink(li);
        if (!link) continue;
        if (navLabel(link) !== 'shop') continue;
        var sub = navSublist(li);
        if (!sub || sub.querySelector('[data-rnr-nav-series]')) return;
        var sibling = sub.querySelector(':scope > li');
        if (!sibling) return;
        groups.forEach(function (g) {
          var clone = sibling.cloneNode(true);
          var a = clone.querySelector('a');
          if (!a) return;
          clone.setAttribute('data-rnr-nav-series', '');
          a.setAttribute('href', g.url);
          a.removeAttribute('aria-current');
          var textNode = null;
          a.childNodes.forEach(function (n) { if (n.nodeType === 3 && n.textContent.trim()) textNode = n; });
          if (textNode) { textNode.textContent = g.label; } else { a.textContent = g.label; }
          sub.appendChild(clone);
        });
        return;
      }
    }
    document.querySelectorAll('.site-nav, #NavDrawer, .drawer').forEach(inject);
  }

  /* Preview-only nav corrections. See snippets/rnr-preview-nav.liquid for why
     this runs in the browser rather than in the Shopify menu editor: menus are
     store-level, and this store is live. */
  function previewNavFix() {
    var cfg = window.RNR_NAV_FIX;
    if (!cfg) return;

    function itemsIn(root) { return root.querySelectorAll('li'); }

    function apply(root) {
      /* Retarget first: a link that is about to be renamed should not also be
         matched by the hide list under its old href. */
      Object.keys(cfg.relabel || {}).forEach(function (href) {
        root.querySelectorAll('a[href$="' + href + '"]').forEach(function (a) {
          var textNode = null;
          a.childNodes.forEach(function (n) { if (n.nodeType === 3 && n.textContent.trim()) textNode = n; });
          if (textNode) { textNode.textContent = cfg.relabel[href]; } else { a.textContent = cfg.relabel[href]; }
          a.setAttribute('data-rnr-nav-relabelled', '');
        });
      });

      /* Some entries are hidden from the menus but still belong in the footer:
         the service form is not a menu destination, yet Quick Links is exactly
         where someone looks for it. */
      var inFooter = !!(root.classList && root.classList.contains('site-footer'));
      var hideList = (cfg.hide || []).slice();
      if (!inFooter) { hideList = hideList.concat(cfg.hide_nav_only || []); }

      hideList.forEach(function (href) {
        root.querySelectorAll('a[href$="' + href + '"]').forEach(function (a) {
          var li = a.closest('li');
          if (!li) return;
          /* Two of these entries name a group header, not a row: Shop points at
             /collections and Resources at /pages/resources, and in the mobile
             drawer the header carries that href itself. Hiding the li took the
             whole group with it, which is why Shop vanished on a phone.

             What was actually asked for is narrower -- the dropdown keeps its
             children, only the parent stops being a destination -- so a header
             gets its link removed rather than its row hidden. Motion renders
             the label and the expand chevron as separate controls, so the group
             still opens; the label forwards its clicks to that chevron, and an
             anchor with no href is no longer focusable, which leaves one
             keyboard stop for the one control. */
          if (li.querySelector('ul, ol')) {
            var trigger = li.querySelector('.collapsible-trigger');
            if (!a.hasAttribute('data-rnr-nav-nolink')) {
              a.removeAttribute('href');
              a.setAttribute('data-rnr-nav-nolink', '');
              /* Motion also binds a handler further up that reads this
                 anchor's href and navigates to it. With the href gone that
                 handler sent the drawer to /pages/null, so the click has to be
                 stopped here rather than merely default-prevented. */
              a.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                if (trigger) { trigger.click(); }
              });
            }
            return;
          }
          li.hidden = true; li.setAttribute('data-rnr-nav-hidden', '');
        });
      });

      (cfg.add || []).forEach(function (item) {
        var list = itemsIn(root);
        for (var i = 0; i < list.length; i++) {
          var li = list[i];
          var link = navParentLink(li);
          if (!link) continue;
          if (navLabel(link) !== item.parent.toLowerCase()) continue;
          var sub = navSublist(li);
          if (!sub) continue;
          if (sub.querySelector('a[href$="' + item.url + '"]')) return;
          /* Clone a sibling so the new row inherits Motion's classes rather
             than being styled separately. */
          var sibling = sub.querySelector(':scope > li:not([hidden])') ||
                        sub.querySelector(':scope > li');
          if (!sibling) return;
          var clone = sibling.cloneNode(true);
          var a = clone.querySelector('a');
          if (!a) return;
          clone.setAttribute('data-rnr-nav-added', '');
          clone.hidden = false;
          clone.removeAttribute('data-rnr-nav-hidden');
          a.setAttribute('href', item.url);
          a.removeAttribute('aria-current');
          var textNode = null;
          a.childNodes.forEach(function (n) { if (n.nodeType === 3 && n.textContent.trim()) textNode = n; });
          if (textNode) { textNode.textContent = item.label; } else { a.textContent = item.label; }
          if (item.first) { sub.insertBefore(clone, sub.firstElementChild); }
          else { sub.appendChild(clone); }
          return;
        }
      });
    }

    /* Ordering runs after hide and add, on the same roots, so it can sort real
       menu entries and added rows together. Items are moved rather than
       recreated: a menu is store-level, and the point here is only to preview
       the order to set in the admin. */
    function reorder(root) {
      Object.keys(cfg.order || {}).forEach(function (parent) {
        var list = itemsIn(root);
        for (var i = 0; i < list.length; i++) {
          var link = navParentLink(list[i]);
          if (!link || navLabel(link) !== parent.toLowerCase()) continue;
          var sub = navSublist(list[i]);
          if (!sub) continue;
          cfg.order[parent].forEach(function (href) {
            var a = sub.querySelector(':scope > li a[href$="' + href + '"]');
            var li = a && a.closest('li');
            /* Only rows that are direct children of this sublist, so a nested
               menu cannot have a row pulled out of it. */
            if (li && li.parentNode === sub) { sub.appendChild(li); }
          });
          /* Anything unlisted has been left in place and is now above the
             sorted rows, so send it to the end in its original order. */
          [].slice.call(sub.children).forEach(function (li) {
            var a = li.querySelector('a');
            var href = a && a.getAttribute('href');
            var known = href && cfg.order[parent].some(function (h) { return href.indexOf(h) !== -1; });
            if (!known) { sub.appendChild(li); }
          });
          return;
        }
      });
    }

    /* Turn plain top-level links into dropdowns by copying an existing one
       (Resources), so they take Motion's markup, classes and open behaviour.
       Each new list starts with one hidden placeholder row: add() clones a
       sibling row to build the real ones, and it runs after hide(), which
       matters because Book a Service Call is hidden from Services by href. */
    function makeDropdowns() {
      (cfg.dropdowns || []).forEach(function (parent) {
        var want = parent.toLowerCase();
        var slug = 'rnr-' + want.replace(/[^a-z0-9]+/g, '-');

        document.querySelectorAll('.site-nav.site-navigation').forEach(function (nav) {
          var target = null, tpl = null, tplFallback = null;
          [].slice.call(nav.children).forEach(function (li) {
            var l = navParentLink(li);
            if (!l) return;
            var name = navLabel(l);
            if (name === want && !li.querySelector(':scope > details')) target = li;
            if (name === 'resources' && li.querySelector(':scope > details > ul')) tpl = li;
            /* Resources itself can be the one being built (1 Oct 2026), so
               Services stands in as the pattern when there is no Resources yet. */
            if (!tpl && name === 'services' && li.querySelector(':scope > details > ul')) tplFallback = li;
          });
          if (!tpl) tpl = tplFallback;
          if (!target || !tpl) return;
          var href = (target.querySelector(':scope > a') || {}).getAttribute ? target.querySelector(':scope > a').getAttribute('href') : '';
          var clone = tpl.cloneNode(true);
          clone.classList.remove('site-nav--active', 'rnr-nav--current');
          var details = clone.querySelector(':scope > details');
          details.id = 'site-nav-item--' + slug;
          details.removeAttribute('open');
          var summary = details.querySelector(':scope > summary');
          summary.setAttribute('aria-controls', details.id);
          summary.setAttribute('aria-expanded', 'false');
          if (href) summary.setAttribute('data-link', href);
          summary.childNodes.forEach(function (n) { if (n.nodeType === 3 && n.textContent.trim()) n.textContent = ' ' + parent + ' '; });
          var ul = details.querySelector(':scope > ul');
          [].slice.call(ul.children).forEach(function (row, i) { if (i > 0) row.remove(); });
          if (ul.firstElementChild) { ul.firstElementChild.hidden = true; ul.firstElementChild.setAttribute('data-rnr-nav-placeholder', ''); }
          target.replaceWith(clone);
        });

        var drawer = document.getElementById('NavDrawer');
        if (!drawer) return;
        var dTarget = null, dTpl = null, dFallback = null;
        drawer.querySelectorAll('.mobile-nav > li').forEach(function (li) {
          var l = navParentLink(li);
          if (!l) return;
          var name = navLabel(l);
          if (name === want && !navSublist(li)) dTarget = li;
          if (name === 'resources' && navSublist(li)) dTpl = li;
          if (name === 'services' && navSublist(li)) dFallback = li;
        });
        if (!dTpl) dTpl = dFallback;
        /* The Services group is the theme's own markup, not Motion's, so when
           Resources is the one being built there is no group to copy: make one
           in Motion's drawer shape, borrowing an existing expand icon. */
        if (!dTpl || !dTpl.querySelector('.mobile-nav__has-sublist > a')) {
          var anyBtn = drawer.querySelector('.collapsible-trigger');
          var shell = document.createElement('ul');
          shell.innerHTML = '<li class="mobile-nav__item"><div class="mobile-nav__has-sublist">' +
            '<a href="#" class="mobile-nav__link" id="Label-rnr-x">x</a>' +
            '<div class="mobile-nav__toggle"><button type="button" class="collapsible-trigger collapsible--auto-height" aria-controls="Linklist-rnr-x" aria-labelledby="Label-rnr-x">' +
            (anyBtn ? anyBtn.innerHTML : '') + '</button></div></div>' +
            '<div id="Linklist-rnr-x" class="mobile-nav__sublist collapsible-content collapsible-content--all"><div class="collapsible-content__inner">' +
            '<ul class="mobile-nav__sublist"><li class="mobile-nav__item"><div class="mobile-nav__child-item"><a href="#" class="mobile-nav__link">x</a></div></li></ul>' +
            '</div></div></li>';
          dTpl = shell.firstElementChild;
        }
        if (!dTarget || !dTpl) return;
        var dClone = dTpl.cloneNode(true);
        dClone.className = dTarget.className;
        var label = dClone.querySelector('.mobile-nav__has-sublist > a');
        var btn = dClone.querySelector('.collapsible-trigger');
        var box = dClone.querySelector('.collapsible-content');
        if (!label || !btn || !box) return;
        /* The label opens the group rather than going to a page, as Shop and
           Resources do: Send Us a Message is the Contact page, one tap below. */
        label.id = 'Label-' + slug;
        label.removeAttribute('href');
        label.removeAttribute('data-rnr-nav-nolink');
        label.setAttribute('data-rnr-nav-nolink', '');
        label.childNodes.forEach(function (n) { if (n.nodeType === 3 && n.textContent.trim()) n.textContent = ' ' + parent + ' '; });
        label.addEventListener('click', function (e) { e.preventDefault(); e.stopImmediatePropagation(); btn.click(); });
        box.id = 'Linklist-' + slug;
        box.classList.remove('is-open');
        box.removeAttribute('style');
        btn.classList.remove('is-open');
        btn.setAttribute('aria-controls', box.id);
        btn.setAttribute('aria-labelledby', label.id);
        btn.setAttribute('aria-expanded', 'false');
        var dUl = navSublist(dClone);
        [].slice.call(dUl.children).forEach(function (row, i) { if (i > 0) row.remove(); });
        if (dUl.firstElementChild) { dUl.firstElementChild.hidden = true; dUl.firstElementChild.setAttribute('data-rnr-nav-placeholder', ''); }
        dTarget.replaceWith(dClone);
      });
    }
    /* Top-level rows the theme supplies itself (1 Oct 2026): Resources lost its
       store-menu row when its page was deleted at launch, and Shopify removes a
       menu row together with the page it links to. Built here from the About
       row, so it no longer depends on any page existing. Skipped if the store
       menu has the row. */
    function insertTopLevel() {
      (cfg.insert || []).forEach(function (item) {
        var want = item.label.toLowerCase();
        var before = (item.before || '').toLowerCase();
        var roots = [].slice.call(document.querySelectorAll('.site-nav.site-navigation'));
        var drawerList = document.querySelector('#NavDrawer .mobile-nav');
        if (drawerList) roots.push(drawerList);
        roots.forEach(function (list) {
          var have = false, anchor = null;
          [].slice.call(list.children).forEach(function (li) {
            var l = navParentLink(li);
            if (!l) return;
            var name = navLabel(l);
            if (name === want) have = true;
            if (name === before && li.querySelector(':scope > a')) anchor = li;
          });
          if (have || !anchor) return;
          var row = anchor.cloneNode(true);
          row.classList.remove('site-nav--active', 'rnr-nav--current');
          var a = row.querySelector(':scope > a');
          a.setAttribute('href', item.url);
          a.removeAttribute('aria-current');
          a.childNodes.forEach(function (n) { if (n.nodeType === 3 && n.textContent.trim()) n.textContent = ' ' + item.label + ' '; });
          anchor.parentNode.insertBefore(row, anchor);
        });
      });
    }
    insertTopLevel();
    makeDropdowns();

    document.querySelectorAll('.site-nav, #NavDrawer, .drawer, .site-footer').forEach(function (root) {
      apply(root);
      reorder(root);
    });

    /* add() builds each real row by cloning the placeholder, so the clones
       carry its marker too; only the original, never shown, is removed. */
    document.querySelectorAll('[data-rnr-nav-placeholder]').forEach(function (row) {
      if (row.hasAttribute('data-rnr-nav-added')) { row.removeAttribute('data-rnr-nav-placeholder'); return; }
      row.remove();
    });
    if ((cfg.dropdowns || []).length && window.theme && theme.collapsibles && theme.collapsibles.init) {
      var navDrawer = document.getElementById('NavDrawer');
      if (navDrawer) theme.collapsibles.init(navDrawer);
    }

    /* Retarget runs last and over the whole document, not per nav root. Two
       reasons it cannot live inside apply(): the links added above do not exist
       yet while apply() is running, and body content links to these pages too -
       the services hub, the homepage services row and the contact routes all
       point at them. */
    Object.keys(cfg.retarget || {}).forEach(function (from) {
      /* href$= alone also matches /pages/x inside /pages/y?view=x, so a
         rewritten link would be rewritten again. Skip anything with a query. */
      document.querySelectorAll('a[href$="' + from + '"]:not([href*="?"])').forEach(function (a) {
        a.setAttribute('href', cfg.retarget[from]);
        a.setAttribute('data-rnr-nav-retargeted', from);
      });
    });
  }

  /* The newsletter tag follows the consent box rather than being sent on every
     signup. Shopify records the consent itself from contact[accepts_marketing];
     the tag exists so the list is readable in the admin, and it should say the
     same thing the consent does. Without JavaScript the box still posts consent
     and only the tag is missed, which is the safe way round to fail. */
  function guideOptinTag() {
    document.querySelectorAll('[data-rnr-optin]').forEach(function (box) {
      if (box.dataset.rnrOptinReady) return;
      box.dataset.rnrOptinReady = '1';
      var form = box.closest('form');
      var tags = form && form.querySelector('[data-rnr-tags]');
      if (!tags) return;
      var base = tags.value;
      box.addEventListener('change', function () {
        tags.value = box.checked ? base + ',newsletter' : base;
      });
    });
  }

  /* Either-or requirements, which HTML cannot express. A service call needs a
     way to reach someone - email or phone, either will do - and a cover cannot
     be sized from a name alone: it needs the model, or a length and a width.

     A group is satisfied when any one option has all of its fields filled, so
     [data-rnr-opt="size"] on both length and width means the pair counts only
     together. Checked on submit rather than on every keystroke, so nobody is
     told they are wrong while still typing. Without JavaScript the form still
     sends - a submission missing a phone number beats a form that refuses. */
  function formRequireOne() {
    document.querySelectorAll('[data-rnr-group]:not([data-rnr-group-ready])').forEach(function (group) {
      var form = group.closest('form');
      if (!form) return;
      group.setAttribute('data-rnr-group-ready', '');
      if (form.hasAttribute('data-rnr-validate-ready')) return;
      form.setAttribute('data-rnr-validate-ready', '');

      form.addEventListener('submit', function (e) {
        var firstBad = null;
        form.querySelectorAll('[data-rnr-group]').forEach(function (g) {
          var name = g.getAttribute('data-rnr-group');
          var fields = [].slice.call(g.querySelectorAll('[data-rnr-opt]'));
          var opts = {};
          fields.forEach(function (f) {
            var k = f.getAttribute('data-rnr-opt');
            if (!opts[k]) opts[k] = [];
            opts[k].push(f);
          });
          var ok = Object.keys(opts).some(function (k) {
            return opts[k].every(function (f) { return (f.value || '').trim() !== ''; });
          });
          var err = form.querySelector('[data-rnr-group-error="' + name + '"]');
          if (err) err.hidden = ok;
          fields.forEach(function (f) {
            f.classList.toggle('rnr-field-invalid', !ok);
            /* aria-invalid only while it is actually invalid - leaving it set
               to false on every field is noise for a screen reader. */
            if (ok) { f.removeAttribute('aria-invalid'); } else { f.setAttribute('aria-invalid', 'true'); }
          });
          if (!ok && !firstBad) firstBad = fields[0];
        });
        if (firstBad) {
          e.preventDefault();
          firstBad.focus();
          var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          firstBad.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
        }
      });
    });
  }

  /* Shopify sends the visitor back to the page after a successful post, so the
     confirmation is a fresh page load rather than something that appears in
     place. Moving focus to it is what tells a screen reader anything happened. */
  function formSuccessFocus() {
    var panel = document.querySelector('[data-rnr-form-success]');
    if (!panel || panel.hasAttribute('data-rnr-focused')) return;
    panel.setAttribute('data-rnr-focused', '');
    panel.focus();
  }

  /* Facade embeds for rnr-video-row. Nothing from YouTube loads until someone
     presses a card - no iframe, no script, no cookie - so a page of four clips
     costs four thumbnails. On press the thumbnail is replaced in place by the
     player, and autoplay is set because the press is the request to play. */
  function videoFacades() {
    document.querySelectorAll('[data-rnr-video]:not([data-rnr-video-ready])').forEach(function (btn) {
      btn.setAttribute('data-rnr-video-ready', '');
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-rnr-video');
        var title = btn.getAttribute('data-rnr-video-title') || 'Video';
        var frame = btn.querySelector('.rnr-video__frame');
        if (!id || !frame) return;
        var iframe = document.createElement('iframe');
        iframe.setAttribute('src', 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) +
          '?autoplay=1&rel=0&playsinline=1');
        iframe.setAttribute('title', title);
        iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        frame.innerHTML = '';
        frame.appendChild(iframe);
        /* The card stops being a button once it holds a player: leaving it as
           one would put a control around the player's own controls. */
        var label = btn.querySelector('.rnr-video__label');
        var wrap = document.createElement('div');
        wrap.className = 'rnr-video';
        wrap.appendChild(frame);
        if (label) wrap.appendChild(label);
        btn.replaceWith(wrap);
        var f = wrap.querySelector('iframe');
        if (f) f.focus();
      });
    });
  }

  /* Motion's testimonials section takes a background colour from the theme
     editor and writes it inline, so there is no class to hang dark styling on.
     Measure it and tag the section instead. */
  function testimonialsDarkGround() {
    document.querySelectorAll('.testimonials-section').forEach(function (s) {
      var bg = getComputedStyle(s).backgroundColor;
      var m = (bg.match(/[\d.]+/g) || []).map(Number);
      if (m.length < 3) return;
      function lin(c) { c /= 255; return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); }
      var L = 0.2126 * lin(m[0]) + 0.7152 * lin(m[1]) + 0.0722 * lin(m[2]);
      s.classList.toggle('testimonials-section--dark', L < 0.2);
    });
  }

  function testimonialArrows() {
    document.querySelectorAll('[data-section-type="testimonials"]').forEach(function (section) {
      if (section.dataset.rnrStatic === '1') return;
      if (section.querySelector('.rnr-carousel-nav')) return;
      var dotsWrap = section.querySelector('.flickity-page-dots');
      if (!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.dot');
      if (dots.length < 2) return;

      var nav = document.createElement('div');
      nav.className = 'rnr-carousel-nav';

      function makeButton(label, delta) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'rnr-carousel-nav__btn';
        b.setAttribute('aria-label', label);
        b.innerHTML = delta < 0
          ? '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M14.5 5 8 12l6.5 7" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
          : '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9.5 5 16 12l-6.5 7" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        b.addEventListener('click', function () {
          var list = dotsWrap.querySelectorAll('.dot');
          var current = 0;
          list.forEach(function (d, i) { if (d.classList.contains('is-selected')) current = i; });
          var next = Math.min(list.length - 1, Math.max(0, current + delta));
          if (list[next]) list[next].click();
        });
        return b;
      }

      nav.appendChild(makeButton('Previous testimonials', -1));
      nav.appendChild(makeButton('Next testimonials', 1));
      /* Under the cards, not beside the heading: the control belongs next to
         the thing it moves. */
      dotsWrap.parentNode.insertBefore(nav, dotsWrap);
    });
  }

  /* Customer quotes are verbatim and must never be line-clamped. Flickity's
     adaptiveHeight would otherwise resize the carousel as different reviews
     become selected, so measure the longest complete card at the current
     viewport width and use that stable height for the whole row. */
  /* Motion initialises the testimonials carousel without `contain`, and its
     init wins because ours bails when flickity-enabled is already set. Without
     it the track can rest past the first cell, leaving an empty slot on the
     left and pushing the last card out of view - the third testimonial
     "disappearing". Force contain on whatever instance exists, and snap back
     if the track has drifted. */
  function containTestimonials() {
    document.querySelectorAll('[data-section-type="testimonials"]').forEach(function (section) {
      var slideshow = section.querySelector('[id^="Testimonials-"]');
      if (!slideshow) return;
      var fl = window.Flickity && window.Flickity.data(slideshow);
      if (!fl) return;
      if (fl.options.contain !== true || fl.options.wrapAround) {
        fl.options.contain = true;
        fl.options.wrapAround = false;
        if (typeof fl.resize === 'function') fl.resize();
      }
      if (typeof fl.x === 'number' && fl.x > 1 && typeof fl.select === 'function') {
        fl.select(0, false, true);
      }
    });
  }

  function equalizeTestimonialHeights() {
    document.querySelectorAll('[data-section-type="testimonials"]').forEach(function (section) {
      var slideshow = section.querySelector('[id^="Testimonials-"]');
      if (!slideshow) return;
      var cards = slideshow.querySelectorAll('.testimonials-slider__text');
      if (!cards.length) return;

      slideshow.style.removeProperty('--rnr-testimonial-height');

      /* Only one card is visible below 750px, so a shared height buys nothing
         and leaves the shorter reviews sitting above hundreds of pixels of
         blank card. Let each slide size to its own quote instead. */
      if (window.matchMedia('(max-width: 749px)').matches) {
        var fl = window.Flickity && window.Flickity.data(slideshow);
        if (fl) {
          fl.options.adaptiveHeight = true;
          if (typeof fl.resize === 'function') fl.resize();
        }
        return;
      }

      var tallest = 0;
      cards.forEach(function (card) {
        tallest = Math.max(tallest, card.scrollHeight);
      });
      if (!tallest) return;

      slideshow.style.setProperty('--rnr-testimonial-height', Math.ceil(tallest) + 'px');
      var flickity = window.Flickity && window.Flickity.data(slideshow);
      if (flickity) {
        flickity.options.adaptiveHeight = false;
        if (typeof flickity.resize === 'function') flickity.resize();
      }
    });
  }

  /* Generic scroll-snap carousel. Any section can opt in with
     [data-rnr-carousel] containing a scrollable track and prev/next buttons.
     Controls stay hidden when everything already fits, so they never appear as
     decoration. */
  function scrollCarousels() {
    document.querySelectorAll('[data-rnr-carousel]').forEach(function (root) {
      var track = root.querySelector('[tabindex="0"]');
      var prev = root.querySelector('[data-carousel-prev]');
      var next = root.querySelector('[data-carousel-next]');
      var controls = root.querySelector('[data-carousel-controls]');
      var readout = root.querySelector('[data-carousel-count]');
      if (!track || !prev || !next || !controls) return;

      function step() {
        var item = track.firstElementChild;
        if (!item) return track.clientWidth;
        /* 28 was the install gallery's gap, hard-coded. The product gallery's
           is 12, so a step there overshot by more than a thumbnail. Read it. */
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return item.getBoundingClientRect().width + gap;
      }
      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        controls.hidden = max <= 0;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
        if (readout) {
          var total = track.children.length;
          var per = Math.max(1, step());
          var at = Math.min(total, Math.max(1, Math.round(track.scrollLeft / per) + 1));
          /* No leading zeros. "01 / 06" is a counter from a camera back; the
             gallery has six photographs, not six hundred, so the padding was
             borrowing a formality the number does not have. Tabular figures on
             the element already stop the readout jittering as it counts up. */
          readout.textContent = total > 1 ? at + ' / ' + total : '';
        }
      }
      if (!root.dataset.carouselBound) {
        prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
        next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
        track.addEventListener('scroll', sync, { passive: true });
        root.dataset.carouselBound = '1';
      }
      sync();
    });
  }

  /* Undesigned pages render Motion's page-title h1 and then whatever the page
     record's rich text contains - which on a few legacy pages is a second h1 of
     its own, so the page ships with two. The record is store-level content and
     main-page.liquid is Motion's, so neither can be edited here. The page title
     is the better h1 of the two, so any later one in the body drops a level. */
  function singleH1() {
    var h1s = document.querySelectorAll('#MainContent h1');
    if (h1s.length < 2) return;
    Array.prototype.slice.call(h1s, 1).forEach(function (h) {
      var h2 = document.createElement('h2');
      h2.innerHTML = h.innerHTML;
      if (h.className) h2.className = h.className;
      h.parentNode.replaceChild(h2, h);
    });
  }

  /* Product descriptions come from the product record, where headings are
     whatever level the merchant picked in Shopify's editor - usually h4,
     because that is what the toolbar offers. Dropped under the product title
     that reads as h1 > h4, a skipped level. The description's own hierarchy is
     kept; it is just shifted so its shallowest heading lands at h2. */
  function normaliseBodyHeadings() {
    document.querySelectorAll('.rnr-showcase__body').forEach(function (body) {
      var hs = body.querySelectorAll('h1,h2,h3,h4,h5,h6');
      if (!hs.length) return;
      var min = 6;
      hs.forEach(function (h) { min = Math.min(min, +h.tagName[1]); });
      if (min === 2) return;
      var shift = 2 - min;
      Array.prototype.slice.call(hs).forEach(function (h) {
        var lvl = Math.min(6, Math.max(2, +h.tagName[1] + shift));
        if (lvl === +h.tagName[1]) return;
        var n = document.createElement('h' + lvl);
        n.innerHTML = h.innerHTML;
        if (h.className) n.className = h.className;
        h.parentNode.replaceChild(n, h);
      });
    });
  }

  /* The Shop menu with Miranda's accessories, chemicals and parts groups
     (approved 14 Sep 2026, option A). The groups come from
     snippets/rnr-shop-menu as <template>s; this puts them in place.

     Desktop: the short Shop list becomes one wide panel. The spa rows are the
     real menu's own rows, moved rather than copied, so a row hidden by
     RNR_NAV_FIX stays hidden. The single "Accessories, Chemicals & Parts" row
     is dropped, since the groups replace it.

     Phone: the groups go into the drawer's Shop list as Motion third-level
     rows, then Motion's collapsible script is re-run so they open. Runs after
     previewNavFix, and only once per list.

     Revised 14 Sep 2026 (menu option 3, A): Hot Tubs has its own first column
     and drawer group, built from the template, so the store's plain Hot Tubs
     row is dropped. Financing leaves Shop for Resources (RNR_NAV_FIX adds it
     there). The row for the page you are on gets the red line. */
  function shopMenu() {
    var megaTpl = document.getElementById('RnrShopMegaTemplate');
    var drawerTpl = document.getElementById('RnrShopDrawerTemplate');
    if (!megaTpl || !drawerTpl) return;
    var dropHrefs = ['/collections/hot-tub-accessories', '/collections/hot-tubs-vita-spa-maax-spas', '/pages/financing', '/pages/refurbished-hot-tubs'];

    function isAccRow(li) {
      var a = li.querySelector(':scope > a, :scope > div > a');
      return a && dropHrefs.indexOf((a.getAttribute('href') || '').replace(/[?#].*$/, '')) !== -1;
    }

    /* The page you are on. A link matches when its path matches and every
       choice it carries (?seats=, ?plug=, ?type= and the older ?size=, ?level=) matches the address too, so
       "All Hot Tubs" is current with nothing picked and "Small" with ?size=small. */
    function markCurrent(root) {
      var here = window.location.pathname.replace(/\/$/, '');
      var params = new URLSearchParams(window.location.search);
      root.querySelectorAll('a[href]').forEach(function (a) {
        var u;
        try { u = new URL(a.getAttribute('href'), window.location.origin); } catch (e) { return; }
        /* A row that jumps to a shelf is only current when that shelf is the
           one in the address; otherwise All Hot Tubs and InnovaSpas both lit
           up, since they share a path. */
        var on = u.pathname.replace(/\/$/, '') === here && (u.hash || '') === (window.location.hash || '');
        // seats, price and plug since the dropdown filters (launch QA, 1 Oct 2026).
        ['size', 'level', 'type', 'seats', 'price', 'plug'].forEach(function (k) {
          if ((u.searchParams.get(k) || '') !== (params.get(k) || '')) on = false;
        });
        if (on) {
          a.setAttribute('aria-current', 'page');
          a.classList.add('rnr-menu-here');
        } else if (a.classList.contains('rnr-menu-here')) {
          a.removeAttribute('aria-current');
          a.classList.remove('rnr-menu-here');
        }
      });
    }

    document.querySelectorAll('.site-nav > li').forEach(function (li) {
      var summary = li.querySelector(':scope > details > summary');
      if (!summary || navLabel(summary) !== 'shop') return;
      var details = summary.parentNode;
      var list = details.querySelector(':scope > ul.site-nav__dropdown');
      if (!list || details.querySelector('.rnr-shopmega')) return;
      var panel = megaTpl.content.firstElementChild.cloneNode(true);
      /* Menu option A (28 Sep 2026): the photo tiles and lists in the panel
         cover every row of the store's Shop menu, so those rows are not moved
         in. A panel that still has a spa column gets them, as before. */
      var spas = panel.querySelector('[data-rnr-shopmega-spas]');
      if (spas) {
        [].slice.call(list.children).forEach(function (row) {
          if (isAccRow(row)) return;
          row.className = '';
          var a = row.querySelector('a');
          if (a) a.className = '';
          spas.appendChild(row);
        });
      }
      li.classList.add('site-nav--is-megamenu');
      list.replaceWith(panel);
      markCurrent(panel);
    });

    var drawer = document.getElementById('NavDrawer');
    if (!drawer) return;
    drawer.querySelectorAll('li').forEach(function (li) {
      var link = navParentLink(li);
      if (!link || navLabel(link) !== 'shop') return;
      var sub = navSublist(li);
      if (!sub || sub.querySelector('[data-rnr-shop-group]')) return;
      var frag = drawerTpl.content.cloneNode(true);
      var tiles = frag.querySelector('[data-rnr-shop-tiles]');
      /* With the photo tiles (menu option A, 28 Sep 2026) the store's Shop rows
         all have a place already: the four spa categories are the tiles,
         Refurbished is in the Hot Tubs group, Financing is under Resources. */
      [].slice.call(sub.children).forEach(function (row) {
        if (tiles || isAccRow(row)) row.remove();
      });
      /* The tiles, then Hot Tubs, open the list; the accessory groups follow. */
      var hot = frag.querySelector('[data-rnr-shop-hottubs]');
      if (hot) sub.insertBefore(hot, sub.firstElementChild);
      if (tiles) sub.insertBefore(tiles, sub.firstElementChild);
      /* The Talk to an Expert button closes the whole drawer, not the Shop list. */
      var cta = frag.querySelector('[data-rnr-drawer-cta]');
      var top = li.closest('ul');
      if (cta) {
        if (top && !drawer.querySelector('.rnr-drawer-cta')) { top.appendChild(cta); } else { cta.remove(); }
      }
      sub.appendChild(frag);
      markCurrent(sub);
      /* A group with no page of its own has a plain label; tapping it opens
         the group, as the arrow beside it does. */
      sub.querySelectorAll('[data-rnr-shop-group] > .mobile-nav__child-item > span.mobile-nav__link').forEach(function (label) {
        label.addEventListener('click', function () {
          var btn = label.nextElementSibling;
          if (btn) btn.click();
        });
      });
    });
    if (window.theme && theme.collapsibles && theme.collapsibles.init) {
      theme.collapsibles.init(drawer);
    }
  }


  /* Services menu (option 2, 28 Sep 2026): words only. On desktop the
     dropdown becomes a two-column panel of names with one line each and a
     "Book a service call" card; in the drawer the rows gain the same one
     lines. Built from snippets/rnr-services-menu, like the Shop menu. */
  function servicesMenu() {
    var megaTpl = document.getElementById('RnrServicesMegaTemplate');
    var drawerTpl = document.getElementById('RnrServicesDrawerTemplate');
    if (!megaTpl || !drawerTpl) return;
    document.querySelectorAll('.site-nav > li').forEach(function (li) {
      var summary = li.querySelector(':scope > details > summary');
      if (!summary || navLabel(summary) !== 'services') return;
      var details = summary.parentNode;
      var list = details.querySelector(':scope > ul.site-nav__dropdown');
      if (!list || details.querySelector('.rnr-svcmega')) return;
      li.classList.add('site-nav--is-megamenu');
      list.replaceWith(megaTpl.content.firstElementChild.cloneNode(true));
    });
    var drawer = document.getElementById('NavDrawer');
    if (!drawer) return;
    drawer.querySelectorAll('li').forEach(function (li) {
      var link = navParentLink(li);
      if (!link || navLabel(link) !== 'services') return;
      var sub = navSublist(li);
      if (!sub || sub.querySelector('.rnr-svcdrawer__item')) return;
      [].slice.call(sub.children).forEach(function (row) { row.remove(); });
      sub.appendChild(drawerTpl.content.cloneNode(true));
    });
  }

  /* Resources and Contact as small text panels under their words (28 Sep
     2026), built from snippets/rnr-small-menus. Desktop only; the phone drawer
     keeps the store menu's rows. */
  function smallMenus() {
    [['resources', 'RnrResourcesMenuTemplate'], ['contact', 'RnrContactMenuTemplate']].forEach(function (pair) {
      var tpl = document.getElementById(pair[1]);
      if (!tpl) return;
      document.querySelectorAll('.site-nav > li').forEach(function (li) {
        var summary = li.querySelector(':scope > details > summary');
        if (!summary || navLabel(summary) !== pair[0]) return;
        var list = summary.parentNode.querySelector(':scope > ul.site-nav__dropdown');
        if (!list) return;
        li.classList.add('rnr-smallmenu-host');
        list.replaceWith(tpl.content.firstElementChild.cloneNode(true));
      });
    });
  }

  function init() {
    /* Motion correctly uses a heading around the homepage logo for stores that
       have no hero heading. RnR does have a visible hero h1, so remove the logo
       wrapper from the accessibility heading outline while preserving its link. */
    document.querySelectorAll('.site-header h1').forEach(function (heading) {
      heading.setAttribute('role', 'presentation');
    });
    singleH1();
    normaliseBodyHeadings();
    testimonialTapToCentre();
    testimonialArrows();
    equalizeTestimonialHeights(); containTestimonials();
    testimonialReadMore(); watchTestimonialVisibility();
    relatedCardLinks();
    testimonialAvatars();
    testimonialStatic();
    scrollCarousels();
    googleBadge();
    previewNavExtra();
    previewNavSeries();
    testimonialsDarkGround();
    previewNavFix();
    shopMenu();
    servicesMenu();
    smallMenus();
    videoFacades();
    galleryThumbs();
    collectionSizeNav();
    testimonialCarousel();
    stickyHeader();
    heroOverlayHeader();
    headerCtaAfterHero();
    navCurrentSection();
    newTabHint();
    guideOptinTag();
    formRequireOne();
    formSuccessFocus();
    /* The first measurement runs before webfonts load, so the fallback face
       measures narrower and the bar looks like it fits. Re-check once Jost is
       actually applied, and again on resize. */
    /* Only poll where there is something to re-measure: Motion's testimonial
       slideshow or an [data-rnr-carousel]. Every other page skipped all of it
       anyway, 21 times over. */
    if (document.querySelector('[data-section-type="testimonials"], [data-rnr-carousel]')) {
      var arrowTries = 0;
      var arrowTimer = setInterval(function () {
        testimonialSlideshowFallback();
        testimonialArrows();
        testimonialStatic();
        equalizeTestimonialHeights(); containTestimonials();
        testimonialReadMore();
        scrollCarousels();
        if (++arrowTries > 20) clearInterval(arrowTimer);
      }, 500);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        testimonialCarousel();
            equalizeTestimonialHeights(); containTestimonials();
      });
    }
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { equalizeTestimonialHeights(); containTestimonials(); testimonialReadMore(); scrollCarousels(); testimonialCarousel(); }, 200);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-bind when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', init);

  /* AOS (the fade-in-on-scroll library Motion ships) measures where every
     [data-aos] element sits on the page once, at DOMContentLoaded, and only
     recalculates on resize or orientation change -- disableMutationObserver is
     on, so nothing else refreshes it. Images still loading at that point,
     webfonts swapping in and changing line heights, and our own JS that shows
     or hides content after load (the collection filters, for one) all move
     things below them without ever triggering a recheck. The trigger point an
     element was given can end up needing more scroll than the page actually
     has, and a heading like the FAQ title on a long collection page just never
     appears. `load` fires once everything -- images included -- has settled,
     so one refresh there catches most of it; the collection grid also calls
     this itself after filtering, which is the other half of the fix. */
  window.addEventListener('load', function () {
    if (window.AOS) AOS.refresh();
  });
})();

  /* Product gallery. The thumbnails were images in a list with nothing
     listening to them: clicking one did nothing and the large image never
     changed. Each is a button now, and pressing it swaps the hero. */
  function galleryThumbs() {
    document.querySelectorAll('.rnr-showcase__media').forEach(function (media) {
      var hero = media.querySelector('[data-rnr-hero]');
      var thumbs = media.querySelectorAll('[data-rnr-thumb]');
      if (!hero || !thumbs.length) return;
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var full = btn.getAttribute('data-full');
          if (!full) return;
          hero.setAttribute('src', full);
          hero.setAttribute('srcset', btn.getAttribute('data-srcset') || '');
          hero.setAttribute('alt', btn.getAttribute('data-alt') || '');
          thumbs.forEach(function (other) {
            other.setAttribute('aria-pressed', other === btn ? 'true' : 'false');
          });
        });
      });
    });
  }

  /* The size nav on a grouped collection grid. Every shelf is already on the
     page, so the chips and the phone select move you to one rather than
     filtering: nothing is hidden and nothing has to be fetched.

     The select also follows the scroll, so its value names the shelf you are
     actually looking at instead of going stale after the first jump. Without
     JavaScript the chips still work -- they are ordinary anchors -- and the
     shelves are all there to scroll past. */
  function collectionSizeNav() {
    document.querySelectorAll('[data-rnr-sizenav]').forEach(function (nav) {
      if (nav.dataset.rnrSizenav === 'on') return;
      var select = nav.querySelector('select');
      if (!select) return;
      nav.dataset.rnrSizenav = 'on';

      var targets = [];
      Array.prototype.forEach.call(select.options, function (opt) {
        var el = document.getElementById(String(opt.value).replace(/^#/, ''));
        if (el) targets.push({ el: el, value: opt.value });
      });
      if (!targets.length) return;

      var calm = window.matchMedia('(prefers-reduced-motion: reduce)');

      function goTo(el) {
        var from = window.pageYOffset;
        el.scrollIntoView({ behavior: calm.matches ? 'auto' : 'smooth', block: 'start' });

        // Taking the click over from the browser also takes away the focus move
        // it would have done, which is how a keyboard and a screen reader follow
        // an in-page link. Put it back, without letting the focus itself jump
        // the page and cut the animation short.
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
        try { el.focus({ preventScroll: true }); } catch (e) { /* older browsers */ }

        // A smooth scroll is driven by animation frames, and there are contexts
        // that never run them -- a backgrounded tab, an embedded preview. The
        // control has to move the page in all of them, so if nothing has
        // started shortly after, go there directly.
        if (calm.matches) return;
        window.setTimeout(function () {
          if (Math.abs(window.pageYOffset - from) > 4) return;
          el.scrollIntoView({ behavior: 'auto', block: 'start' });
        }, 220);
      }

      // The chips are real anchors, so they work with JavaScript off and they
      // open in a new tab the way a link should. This only takes over the plain
      // click, to trade the browser's instant jump for the animated one.
      nav.querySelectorAll('a[href^="#"]').forEach(function (link) {
        link.addEventListener('click', function (event) {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;
          var hash = link.getAttribute('href');
          var el = document.getElementById(hash.slice(1));
          if (!el) return;
          event.preventDefault();
          goTo(el);
          select.value = hash;
          // replace rather than push: the chips are a way of moving around one
          // page, not four pages of history to back out through.
          if (window.history && window.history.replaceState) {
            window.history.replaceState(null, '', hash);
          }
        });
      });

      select.addEventListener('change', function () {
        var found = targets.filter(function (t) { return t.value === select.value; })[0];
        if (found) goTo(found.el);
      });

      // The shelf in view is the last one whose heading has passed the upper
      // quarter of the screen; above the first, the first stays named.
      var queued = 0;
      function sync() {
        queued = 0;
        var line = window.innerHeight * 0.25;
        var current = targets[0].value;
        targets.forEach(function (t) {
          if (t.el.getBoundingClientRect().top <= line) current = t.value;
        });
        if (select.value !== current) select.value = current;
      }
      window.addEventListener('scroll', function () {
        if (queued) return;
        queued = window.setTimeout(sync, 100);
      }, { passive: true });
      sync();
    });
  }

  /* The testimonials track. Scroll snap does the paging, so this only wires the
     two arrows to it and hides them when everything already fits.

     Also adds the "Read full review" expander, and only to the quotes that are
     actually cut off by the five-line clamp -- a button under a review that is
     already showing in full is a button that does nothing. */
  function testimonialCarousel() {
    document.querySelectorAll('[data-rnr-quotes]').forEach(function (root) {
      var track = root.querySelector('[data-rnr-quotes-track]');
      var nav = root.querySelector('[data-rnr-quotes-nav]');
      if (!track || !nav) return;

      if (!root.dataset.rnrQuotes) {
        root.dataset.rnrQuotes = 'on';
        var prev = nav.querySelector('[data-rnr-quotes-prev]');
        var next = nav.querySelector('[data-rnr-quotes-next]');
        var calm = window.matchMedia('(prefers-reduced-motion: reduce)');

        function page(dir) {
          var first = track.querySelector('.rnr-quote');
          var step = first ? Math.round(first.getBoundingClientRect().width + 28) : track.clientWidth;
          var by = Math.max(step, Math.round(track.clientWidth * 0.9)) * dir;
          var from = track.scrollLeft;
          track.scrollBy({ left: by, behavior: calm.matches ? 'auto' : 'smooth' });
          // Same reason as the size nav: a smooth scroll needs animation frames,
          // and some contexts never run them.
          // The scroll event re-checks the ends, but it only fires where the
          // page is actually being rendered. Re-check directly after moving so
          // the arrows enable and disable regardless.
          window.setTimeout(ends, 60);
          window.setTimeout(ends, 500);
          if (calm.matches) return;
          window.setTimeout(function () {
            if (Math.abs(track.scrollLeft - from) > 4) return;
            track.scrollLeft = from + by;
            ends();
          }, 220);
        }
        if (prev) prev.addEventListener('click', function () { page(-1); });
        if (next) next.addEventListener('click', function () { page(1); });

        var queued = 0;
        track.addEventListener('scroll', function () {
          if (queued) return;
          queued = window.setTimeout(function () { queued = 0; ends(); }, 90);
        }, { passive: true });

        /* The dots are a phone control: one review fills the screen there, so
           nothing else says how many there are or which one this is. Position
           is read off the scroll rather than counted from the arrows, so a
           swipe moves them too. */
        var dots = [].slice.call(root.querySelectorAll('[data-rnr-quotes-dot]'));
        function stepWidth() {
          var first = track.querySelector('.rnr-quote');
          return first ? first.getBoundingClientRect().width + 28 : track.clientWidth;
        }
        dots.forEach(function (d, i) {
          d.addEventListener('click', function () {
            track.scrollTo({ left: Math.round(stepWidth() * i),
              behavior: calm.matches ? 'auto' : 'smooth' });
            window.setTimeout(ends, 60);
            window.setTimeout(ends, 500);
          });
        });

        root._rnrEnds = function () {
          var max = track.scrollWidth - track.clientWidth;
          if (prev) prev.disabled = track.scrollLeft <= 2;
          if (next) next.disabled = track.scrollLeft >= max - 2;
          if (!dots.length) return;
          var at = Math.round(track.scrollLeft / stepWidth());
          /* The last card cannot scroll a whole step, so the end of the track
             is the last dot however short that final move was. */
          if (track.scrollLeft >= max - 2) at = dots.length - 1;
          at = Math.max(0, Math.min(dots.length - 1, at));
          dots.forEach(function (d, i) {
            d.setAttribute('aria-current', i === at ? 'true' : 'false');
          });
          /* A carousel is as tall as its longest review, which left a short one
             over a field of empty ground. On a phone, one review at a time, the
             track takes the height of the one showing. */
          var cards = track.querySelectorAll('.rnr-quote');
          track.style.blockSize = phone.matches && cards[at] ? cards[at].offsetHeight + 'px' : '';
        };
        var phone = window.matchMedia('(max-width: 749px)');
        window.addEventListener('resize', ends, { passive: true });
      }

      function ends() { if (root._rnrEnds) root._rnrEnds(); }

      // Arrows only earn their place when there is something to scroll to.
      var overflows = track.scrollWidth - track.clientWidth > 24;
      nav.hidden = !overflows;
      ends();

      // A lone review is shown in full, so it never needs an expander.
      if (root.classList.contains('rnr-quotes--single')) return;

      // The expander, re-evaluated on resize because the clamp bites at some
      // widths and not others.
      track.querySelectorAll('[data-rnr-quote-text]').forEach(function (quote) {
        var p = quote.querySelector('p');
        if (!p) return;
        var clipped = p.scrollHeight - p.clientHeight > 2;
        var btn = quote.parentNode.querySelector('.rnr-quote__more');

        if (!clipped && !quote.hasAttribute('data-open')) {
          if (btn) btn.remove();
          return;
        }
        if (btn) return;

        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'rnr-quote__more';
        btn.textContent = 'Read full review';
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', function () {
          var open = quote.toggleAttribute('data-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          btn.textContent = open ? 'Show less' : 'Read full review';
          ends();
        });
        quote.parentNode.appendChild(btn);
      });
    });
  }

  /* The header sticks; the black utility bar above it does not.

     The header group is a set of sibling sections rather than one wrapper, so
     sticking the section that holds .site-header leaves the utility bar to
     scroll away on its own -- which is the condense: 167px of chrome becomes
     about 70 once you are reading. The shrunk state is a class, so the sizes
     live in CSS with the rest of the header. */
  function stickyHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    var section = header.closest('.shopify-section-group-header-group');
    if (!section || section.dataset.rnrSticky) return;
    section.dataset.rnrSticky = 'on';
    section.classList.add('rnr-stickyhead');

    // Condense at the moment the header pins, which is when the bar above it has
    // finished scrolling away. Measured from layout rather than guessed: a fixed
    // 90 left a window where the bar was gone but the header had not changed.
    function pinPoint() { return Math.max(0, section.offsetTop); }
    var queued = 0;
    function sync() {
      queued = 0;
      var small = window.pageYOffset >= pinPoint();
      if (section.classList.contains('rnr-stickyhead--small') !== small) {
        section.classList.toggle('rnr-stickyhead--small', small);
      }
    }
    window.addEventListener('scroll', function () {
      if (queued) return;
      queued = window.setTimeout(sync, 80);
    }, { passive: true });
    sync();
  }

  /* The header sits over the hero photograph until you scroll.

     Every page now opens on a full-bleed image with a short headline, and an
     opaque bar above it capped the picture and made the hero read shorter than
     it is. Over the photo the header goes transparent and white; once it sticks
     it goes solid again.

     Motion already has the light-header mode this needs -- `is-light` turns the
     nav white and swaps the logo for the white mark -- so this only decides
     when to apply it. The hero is pulled up under the header by its own height,
     measured rather than assumed, because the header is taller when the nav
     wraps. */
  /* Home page (1 Oct 2026): the hero already has a red Shop button and the
     Talk to an Expert form, so the header's red Talk to an Expert waits until
     the hero has scrolled away. It keeps its space while hidden, so the menu
     does not shift when it appears. */
  function headerCtaAfterHero() {
    var cta = document.querySelector('.site-header .rnr-header-cta');
    var hero = document.querySelector('.rnr-hero.rnr-hero--form');
    if (!cta || !hero || !('IntersectionObserver' in window)) return;
    if (cta.dataset.rnrWaits) return;
    cta.dataset.rnrWaits = '1';
    cta.classList.add('rnr-header-cta--waiting');
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        cta.classList.toggle('rnr-header-cta--waiting', e.isIntersecting);
      });
    }).observe(hero);
  }

  function heroOverlayHeader() {
    var wrap = document.querySelector('.header-wrapper');
    var header = document.querySelector('.site-header');
    var main = document.querySelector('.main-content');
    if (!wrap || !header || !main) return;

    var first = main.querySelector(':scope > .shopify-section');
    var hero = first && first.querySelector('.rnr-hero');
    // Only over a hero. Anywhere else the header keeps its own ground.
    if (!hero) return;

    var section = header.closest('.shopify-section-group-header-group');
    if (!section) return;
    section.classList.add('rnr-overhero');

    /* Where the overlay ends, captured once rather than read live.

       The header group is itself `position: sticky`, so once it has stuck,
       its own `offsetTop` stops being where it sits in the document and starts
       tracking the current scroll position instead -- measured live, it reads
       79 at the top of the page and 3000 after scrolling 3000px, i.e. it chases
       whatever pageYOffset already is. Comparing the two on every scroll pits a
       moving threshold against the number it is being compared to: most of the
       time they cross cleanly, but a scroll that lands mid-race can leave the
       header transparent with no later scroll event left to correct it, which
       is the stuck-transparent bug. Pinning the value once, before the section
       has had a chance to stick, removes the race entirely. */
    var pin = 0;
    var measuredAt = 0;

    function measure() {
      /* Measure the SECTION, not the header inside it.

         Motion's own `sticky_index` setting already lifts the header out of
         flow on the homepage, so that section is zero tall there and the hero
         is under it by Motion's doing. Measuring .site-header returned 72
         anyway, so the pull-up was applied a second time and dragged the hero
         27px above the top of the page -- over the black utility bar, which is
         what made it look as though the bar had been deleted.

         Where Motion is not already overlaying, the section has its real height
         and the pull-up works as before. Where it is, this is zero and nothing
         moves. */
      /* Every layout read happens before the one style write below: reading
         after writing --rnr-headover on the root forced a full-page style
         recalculation in the middle of start-up. */
      var rect = section.getBoundingClientRect();
      var scrolled = measuredAt = window.pageYOffset;
      var overlaid = header.dataset.sticky === 'true' && window.getComputedStyle(wrap).position === 'absolute';
      var h = Math.round(rect.height);
      var headover = Math.max(0, h) + 'px';
      if (document.documentElement.style.getPropertyValue('--rnr-headover') !== headover) {
        document.documentElement.style.setProperty('--rnr-headover', headover);
      }

      // Re-pinned alongside the height -- but only while the section is still in
      // normal flow. Once it has stuck, its own rect.top reads ~0 (pinned to the
      // viewport), and adding the current scroll position back would just
      // reconstruct whatever pageYOffset already is: exactly the corrupted
      // number this fix exists to get away from. A resize that happens while
      // stuck and deep in the page keeps the last good pin instead, which is
      // right far more often than recomputing it from a stuck rect is.
      var top = rect.top;
      if (top > 1) pin = Math.max(1, Math.round(top + scrolled));

      /* Where Motion itself overlays the header (the homepage: the wrapper is
         absolute and scrolls away with the page), the header does not pin at the
         section's top at all. Motion fixes it and gives it a ground only past
         250px of scroll. Ending the overlay at the section's top left 80-250px
         where the nav had lost its white ink but had no ground yet: dark type
         straight on the photograph, which read as a broken transition
         (Rapolas, 15 Sep 2026). Match Motion's own threshold there instead. */
      if (overlaid) {
        pin = 251;
      }
    }

    /* The overlay ends where the condense begins, so the header is never
       transparent and stuck at the same time.

       The two halves are deliberately out of step. The ground takes 220ms to
       fade, but the white ink and the white logo switch in a single frame -- so
       flipping both at once left white type sitting on a nearly-white ground
       for about a fifth of a second, which is the flash.

       Going solid: start the ground, and hold the white ink until it has mostly
       arrived. Going transparent: put the white ink back immediately, because
       the ground is on its way out and white is the legible one over the
       photograph. Both directions keep the type on the darker of the two. */
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
    var inkTimer = 0;
    var wasOver = null;

    function sync(scrollY) {
      // The overlay ends exactly where the header pins. Anything later leaves a
      // window with the bar above already gone and the nav still transparent,
      // which reads as the top bar having vanished.
      var y = typeof scrollY === 'number' ? scrollY : window.pageYOffset;
      var over = y < pin;
      if (over === wasOver) return;
      wasOver = over;

      section.classList.toggle('rnr-overhero--on', over);
      window.clearTimeout(inkTimer);

      if (over || calm.matches) {
        wrap.classList.toggle('is-light', over);
      } else {
        inkTimer = window.setTimeout(function () {
          wrap.classList.remove('is-light');
        }, 150);
      }
    }

    measure();
    sync(measuredAt); // the scroll position measure() already read; no second layout pass
    // No throttle: this only flips two classes, and a timer put the change up
    // to 60ms behind the scroll, which is long enough to feel like a stutter.
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', function () {
      window.setTimeout(measure, 150);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  }

  /* Which section of the site you are in. Motion marks nothing, so a page deep
     in Shop looked identical to one deep in Services.

     Matched on the longest destination that is a prefix of the current path,
     because several pages sit in more than one menu -- /pages/about-us is both
     "About" and "Testimonials" under Resources, and the longest match is the
     one that actually describes where you are. */
  function navCurrentSection() {
    var nav = document.querySelector('.site-nav.site-navigation');
    if (!nav) return;
    var path = window.location.pathname.replace(/\/$/, '') || '/';
    var best = null;
    var bestLen = 0;

    Array.prototype.forEach.call(nav.children, function (li) {
      li.querySelectorAll('a[href], summary[data-link]').forEach(function (el) {
        var href = el.getAttribute('href') || el.getAttribute('data-link');
        if (!href) return;
        var p = href.split('?')[0].split('#')[0].replace(/\/$/, '');
        if (!p || p === '/') return;
        if ((path === p || path.indexOf(p + '/') === 0) && p.length > bestLen) {
          bestLen = p.length;
          best = li;
        }
      });
    });

    if (!best) return;
    best.classList.add('rnr-nav--current');
    var label = best.querySelector('.site-nav__link');
    if (label) label.setAttribute('aria-current', 'page');
  }

  /* A link that opens a new tab should say so. The document links already do -
     "PDF, opens in a new tab" - but the social marks in the footer did not, so
     a screen reader announced "Instagram, link" and the context changed with no
     warning. Appended rather than authored into the markup because these come
     from Motion's own footer. */
  function newTabHint() {
    /* Google Maps links leave the site, so they open in a new tab wherever they
       come from, menu rows included (a Shopify menu link cannot ask for one).
       It also lets the ads manager's map-click tag record the click before the
       page changes (28 Sep 2026). */
    document.querySelectorAll('a[href*="google.com/maps"]:not([target])').forEach(function (a) {
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener');
    });
    document.querySelectorAll('a[target="_blank"]').forEach(function (a) {
      if (a.dataset.rnrNewTab) return;
      var name = (a.getAttribute('aria-label') || a.textContent || '').toLowerCase();
      if (/new tab|new window|opens/.test(name)) return;
      var hint = document.createElement('span');
      hint.className = 'visually-hidden';
      hint.textContent = ' (opens in a new tab)';
      a.appendChild(hint);
      a.dataset.rnrNewTab = '1';
    });
  }
